<template>
	<div>

		<a-popover trigger="click" placement="bottomLeft">
			<button
				class="ts-flex ts-items-center ts-bg-blue-100 ts-text-blue-500 ts-px-3 ts-space-x-1 ts-rounded focus:ts-outline-none"
				style="height: 2.2rem;">
				<i :class="sortDestination"></i>
				<p class="ts--mb-1">{{ getSortName ? getSortName : $t('dailyCloseout.sort') }}</p>
				<i class="fas fa-angle-down"></i>
			</button>
			<template #content>
				<div class="ts-space-y-2">
					<draggable 
						v-model="model.sort" handle=".handle"
						@change="onSortChange"
					>
						<div v-for="(item, index) in model.sort" :key="index" class="sort-grid ts-space-y-2">
							<div class="ts-justify-center ts-items-center ts-flex">
								<i class="fas fa-grip-vertical handle"></i>
							</div>
							<div class="item-content" style="min-width: 180px;">
								<a-select v-model="item.col" :options="columnItems" class="ts-w-full"></a-select>
							</div>
							<div class="item-content" style="min-width: 110px;">
								<a-select
								 v-model="item.order" :options="sortDescAsc" @change="$emit('fetch')" class="ts-w-full"></a-select>
							</div>
							<button
								class="ts-flex ts-items-center ts-justify-center ts-text-gray-300 hover:ts-text-red-500 ts-duration-200 ts-cursor-pointer focus:ts-outline-none"
								@click.stop="removSort(index)">
								<svg data-prefix="fas" data-icon="circle-xmark" role="img" viewBox="0 0 512 512" aria-hidden="true"
									class="svg-inline--fa fa-circle-xmark">
									<path fill="currentColor"
										d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM167 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"
										class=""></path>
								</svg>
							</button>
						</div>
					</draggable>
					<div>
						<a-popover trigger="click" placement="bottomLeft">
							<button
								class="ts-flex ts-space-x-2 ts-py-1 ts-rounded ts-w-full focus:ts-outline-none ts-duration-200 hover:ts-bg-gray-300"
								style="min-width: 130px;">
								<div class="ts-justify-center ts-items-center ts-flex" style="width: 30px;">
									<i class="fas fa-plus"></i>
								</div>
								<p>{{ $t('dailyCloseout.addSort') }}</p>
							</button>
							<template #content>
								<div class="ts-p-1 ts-space-y-1">
									<a-input v-model="search" :placeholder="$t('dailyCloseout.search')" class="ts-mb-2"></a-input>
									<div v-for="item in columnItems"
										class="ts-py-1 ts-rounded hover:ts-bg-gray-200 hover:ts-text-gray-700 ts-duration-200 ts-px-2 ts-cursor-pointer ts-space-x-2"
										@click.stop="onAddHandler(item)">
										<i :class="iconType(item.type)"></i>
										{{ item.label }}
									</div>
								</div>
							</template>
						</a-popover>
						<button
							@click="clearSort"
							class="ts-flex ts-space-x-2 ts-py-1 ts-rounded ts-w-full focus:ts-outline-none ts-duration-200 hover:ts-bg-gray-300 hover:ts-text-red-500"
							style="min-width: 130px;">
							<div class="ts-justify-center ts-items-center ts-flex" style="width: 30px;">
								<i class="fas fa-trash"></i>
							</div>
							<p>{{ $t('dailyCloseout.clearSort') }}</p>
						</button>
					</div>
				</div>
			</template>
		</a-popover>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import { columns } from '../config';

export default {
	components: {
		draggable,
	},
	props: ['value'],
	data() {
		return {
			model: {},
			search: undefined
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		sortDescAsc() {
			return [
				{ value: 'asc', label: 'Ascending' },
				{ value: 'desc', label: 'Descending' },
			]
		},
		columnItems() {
			const search = (this.search || '').toLowerCase()
			return columns()
				.map(el => ({
					value: el.key || el.col,
					label: this.$t(`dailyCloseout.${el.label}`),
					type: el.type
				}))
				.filter(item => item.label.toLowerCase().includes(search))
		},
		iconType: () => type => {
			if (type == 'text') {
				return 'fas fa-font'
			}
			if (type == 'date') {
				return 'far fa-clock'
			}
			if (type == 'number') {
				return 'fas fa-dollar-sign'
			}

			return 'fas fa-circle'
		},
		getSortName() {
			if (this.model.sort.length === 1) {
				return this.model.sort[0].text
			}

			return undefined
		},
		sortDestination() {
			if (this.model.sort.length === 1) {
				const order = this.model.sort[0].order
				if (order === 'asc') {
					return 'fas fa-arrow-up'
				}
				if (order === 'desc') {
					return 'fas fa-arrow-down'
				}
			}

			return 'fas fa-sort'
		}
	},
	methods: {
		onAddHandler(item) {
			this.model.sort.push({
				col: item.value,
				text: item.label,
				order: 'asc'
			})
			this.$emit('fetch')
		},
		removSort(index) {
			this.model.sort.splice(index, 1);
			this.$emit('fetch')
		},
		clearSort() {
			this.model.sort = []
		},
		onSortChange(_value) {
			this.$emit('fetch')
		}
	}
}
</script>


<style scoped>
.sort-grid {
	display: grid;
	grid-template-columns: 30px auto auto 30px;
	column-gap: 10px;
}

.handle {
	cursor: grab;
	/* Grab cursor for the handle only */
	color: #666;
}

.handle:active {
	cursor: grabbing;
}
</style>